// components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = ({ onNavigateToPage }) => {
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription submitted');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">LEADVALA</h3>
            <p className="footer-tagline">AI Tech Driven Lead Solutions</p>
            <p className="footer-desc">
              Revolutionary lead generation combining cutting-edge AI with human intelligence.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook" className="social-link">f</a>
              <a href="#" aria-label="Twitter" className="social-link">t</a>
              <a href="#" aria-label="LinkedIn" className="social-link">in</a>
            </div>
          </div>
          
          <div className="footer-links">
            <h4>Quick Links</h4>
            <button 
              onClick={() => onNavigateToPage('privacy-policy')} 
              className="footer-link"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'none',
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => onNavigateToPage('terms-conditions')} 
              className="footer-link"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'none',
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Terms & Conditions
            </button>
            <button 
              onClick={() => onNavigateToPage('cookie-policy')} 
              className="footer-link"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'none',
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Cookie Policy
            </button>
            <button 
              onClick={() => onNavigateToPage('refund-policy')} 
              className="footer-link"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'none',
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Refund & Cancellation Policy
            </button>
            <button 
              onClick={() => onNavigateToPage('disclaimer')} 
              className="footer-link"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'none',
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Disclaimer
            </button>
          </div>
          
          <div className="footer-links">
            <h4>Services</h4>
            <a href="#services" className="footer-link">Call Verified Leads</a>
            <a href="#services" className="footer-link">OTP Verified Leads</a>
            <a href="#services" className="footer-link">WhatsApp Leads</a>
            <a href="#services" className="footer-link">Custom Solutions</a>
          </div>
          
          <div className="footer-newsletter">
            <h4>Get Free Business Report</h4>
            <p>Subscribe to receive your free insider report and latest updates</p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-button">
                Subscribe
              </button>
            </form>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">
            © 2024 LeadVala. All rights reserved. | 
            <button 
              onClick={() => onNavigateToPage('privacy-policy')} 
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: '0 5px',
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Privacy Policy
            </button> | 
            <button 
              onClick={() => onNavigateToPage('terms-conditions')} 
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: '0 5px',
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              Terms of Service
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;